import React, { useState } from 'react';
import { api } from '../api/client';
import { useLanguage } from '../i18n/LanguageContext';

export default function BadgeActionModal({ action, onClose }) {
  const { t } = useLanguage();
  const [badgeNumber, setBadgeNumber] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!badgeNumber.trim()) {
      setError(t('errorBadgeRequired'));
      return;
    }
    setSubmitting(true);
    try {
      await api.logAccess(badgeNumber.trim(), action);
      setSuccess(true);
      setTimeout(onClose, 1200);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        {success ? (
          <div className="form-success">
            <div className="success-icon">✓</div>
            <h2>{t('exitDoneTitle')}</h2>
            <p className="modal-subtitle">{t('exitDoneSubtitle')}</p>
          </div>
        ) : (
          <>
            <h2>{t('exitTitle')}</h2>
            <p className="modal-subtitle">{t('exitInstruction')}</p>
            {error && <div className="form-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="field">
                <input
                  type="text"
                  className="big-badge-input"
                  autoFocus
                  value={badgeNumber}
                  onChange={(e) => setBadgeNumber(e.target.value)}
                  placeholder={t('badgeNumberPlaceholder')}
                />
              </div>
              <div className="btn-row">
                <button type="button" className="btn btn-ghost" onClick={onClose}>{t('cancel')}</button>
                <button type="submit" className="btn btn-primary" disabled={submitting}>
                  {submitting ? '…' : t('exitVerb')}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
